// extracted by css-extract-rspack-plugin
export default {"scrollable":"F2Df1","descriptionLabel":"AxssA"};